import { MapMarkerLeftOutlineIcon } from './MapMarkerLeftOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 0283CCF3-BC73-4642-92FA-38E62D635368
 * name map-marker-left-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-left-outline.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationLeftOutlineIcon = MapMarkerLeftOutlineIcon;
export default LocationLeftOutlineIcon